import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CompanyCom({ title, data, isCentered }) {


  const [isLargeScreen, setIsLargeScreen] = useState(() =>
    window.matchMedia("(min-width: 1280px)").matches
  );
   useEffect(() => {
      const mediaQuery = window.matchMedia("(min-width: 1280px)");
      const handleChange = (e) => setIsLargeScreen(e.matches);
      mediaQuery.addEventListener("change", handleChange);
  
      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    }, []);
  // console.log("Data received by Company component:", data);

  if (!data || !Array.isArray(data)) {
    return <p>Data is not available.</p>;
  }
  

  const settings = {
    infinite: true,
    speed: 3000,
    slidesToShow: 3, // Default: 3 slides
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1280, // For screens less than 350px
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true, // Disable centering for better layout on small screens
          centerPadding: "30px",
        },
      },
    ],

   
  };
 

  return (
    <>
    {isLargeScreen&&
    <div className="d-flex flex-column bg-gray-light uw-315 justify-content-evenly m-0 upy-3"
    style={{
      overflow:"hidden",
    }}>
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold ufs-7 m-0">{title}</p>
      </div>
      <Slider {...settings} pauseOnHover={false} pauseOnDotsHover={false} pauseOnFocus={false}>
        {data[0].items.map((item, index) => (
          <div key={index} className="position-relative d-flex flex-column box-shadow umy-5 p-0 br-5 uh-120 uw-80">
            {/* Image */}
            <div
              className="image-container uh-80 uw-80"
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderTopRightRadius:"calc(var(--unit) * 5) !important",
                borderTopLeftRadius:"calc(var(--unit) * 5) !important",
              }}
            ></div>
            {/* Text below the image */}
            <div className=" text-center"
              style={
                isCentered
                  ? {  display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    height: "25%" }
                  : {}
              }>
              {/* Render names */}
              {Array.isArray(item.name) ? (
                item.name.map((n, i) => (
                  <p key={i} className="m-0 upx-2 upy-1  ufs-6 text-blue fw-bold">
                    {n}
                  </p>
                ))
              ) : (
                <p className="m-0 upx-2 upy-1 ufs-7 text-blue fw-bold">{item.name}</p>
              )}
              <p className="m-0 uyp-1 upx-2 ufs-5 fw-bold">{item.role}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    }{!isLargeScreen&&
      <div className="d-flex flex-column bg-gray-light w-100 justify-content-evenly m-0 upy-3"
    style={{
      overflow:"hidden",
    }}>
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold ufs-14 m-0">{title}</p>
      </div>
      <Slider {...settings} pauseOnHover={false} pauseOnDotsHover={false} pauseOnFocus={false}>
        {data[0].items.map((item, index) => (
          <div key={index} className="position-relative d-flex flex-column box-shadow umy-5 p-0 br-20 w-75">
            {/* Image */}
            <div
              className="image-container uh-250 w-100"
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderTopRightRadius:"calc(var(--unit) * 20) !important",
                borderTopLeftRadius:"calc(var(--unit) * 20) !important",
              }}
            ></div>
            {/* Text below the image */}
            <div className=" text-center uh-60 px-2"
              style={
                isCentered
                  ? {  display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center", 
                    justifyContent: "center", 
                     }
                  : {}
              }>
              {/* Render names */}
              {Array.isArray(item.name) ? (
                item.name.map((n, i) => (
                  <p key={i} className="m-0 upx-2 upy-1  ufs-9 text-blue fw-bold">
                    {n}
                  </p>
                ))
              ) : (
                <p className="m-0 upx-2 upy-1 ufs-14 text-blue fw-bold">{item.name}</p>
              )}
              <p className="m-0 uyp-1 upx-2 ufs-9 fw-bold">{item.role}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    
    }
    
    </>
    
  );
}

export default CompanyCom;

